import { render, staticRenderFns } from "./RegularPromotion.vue?vue&type=template&id=7b42ef8f&scoped=true&"
import script from "./RegularPromotion.vue?vue&type=script&lang=js&"
export * from "./RegularPromotion.vue?vue&type=script&lang=js&"
import style0 from "./RegularPromotion.vue?vue&type=style&index=0&id=7b42ef8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b42ef8f",
  null
  
)

export default component.exports